const getEnv = (name, { required = true, defaultValue = undefined } = {}) => {
    const value = process.env[name];

    if (value) {
        return value;
    }

    if (required) {
        throw new Error(`Missing environment variable "${name}"`);
    }

    return defaultValue;
}

const config = {
    login: getEnv('REACT_APP_LOGIN_URL'),
    logout: getEnv('REACT_APP_LOGOUT_URL'),
    profile: getEnv('REACT_APP_PROFILE_URL'),
    clientId: getEnv('REACT_APP_CLIENT_ID'),
    redirectUri: getEnv('REACT_APP_REDIRECT_URL'),
    redirectLogoutUri: getEnv('REACT_APP_REDIRECT_LOGOUT_URI'),
    uploadUrl: getEnv('REACT_APP_UPLOAD_URI')
}

export default class UrlHelper {

    static buildUrl(base, params) {
        const query = this.buildQuery(params);
        return `${base}${query}`;
    }

    static buildLoginUrl(state) {
        return `${config.login}?client_id=${config.clientId}&redirect_uri=${config.redirectUri}&state=${state || ''}`;
    }

    static buildLogoutUrl(state) {
        return `${config.logout}?client_id=${config.clientId}&logout_uri=${config.redirectLogoutUri}&state=${state || ''}`;
    }

    static buildProfileUrl(state) {
        return `${config.profile}?client_id=${config.clientId}&redirect_uri=${config.redirectUri}&state=${state || ''}`;
    }

    static buildUploadUrl() {
        return `${config.uploadUrl}/upload`;
    }

    static buildTeachingLevelUrl() {
        return `${config.uploadUrl}/levels`;
    }

    static buildSchoolSearchUrl() {
        return `${config.uploadUrl}/school`;
    }

    static buildSchoolWorkUrl() {
        return `${config.uploadUrl}/work`;
    }
    static buildSchoolWorkSearchUrl() {
        return `${config.uploadUrl}/search`;
    }
}